import { t } from 'i18next'

import { ExternalCampaignMetricsStatus } from '../../types'
import StatusBadge from '../StatusBadge'

type UploadRowData = {
  fileName: string
  formattedUploadDate: string
  status: ExternalCampaignMetricsStatus
  channel: string
  placement_name: string
  user_email: string
  user_name: string
  status_detail: string | null
}

const formatChannel = (channel: string): string => {
  const channelMap: Record<string, string> = {
    google_pla: 'Google PLA'
  }
  return channelMap[channel] || channel
}

export const schema = () => ({
  uploadDate: {
    title: t('rm:externalCampaignMetrics.list.column.uploadDate'),
    render: (rowData: UploadRowData) => rowData.formattedUploadDate
  },
  fileName: {
    title: t('rm:externalCampaignMetrics.list.column.fileName'),
    render: (rowData: UploadRowData) => rowData.fileName
  },
  channel: {
    title: t('rm:externalCampaignMetrics.list.column.channel'),
    render: (rowData: UploadRowData) => formatChannel(rowData.channel)
  },
  placement: {
    title: t('rm:externalCampaignMetrics.list.column.placement'),
    render: (rowData: UploadRowData) => rowData.placement_name
  },
  user: {
    title: t('rm:externalCampaignMetrics.list.column.user'),
    render: (rowData: UploadRowData) => rowData.user_name || rowData.user_email
  },
  status: {
    title: t('rm:externalCampaignMetrics.list.column.status'),
    render: (rowData: UploadRowData) => <StatusBadge status={rowData.status} />
  },
  statusDetail: {
    title: t('rm:externalCampaignMetrics.list.column.statusDetail'),
    render: (rowData: UploadRowData) => rowData.status_detail || '-'
  }
})
